export const unverified = 'UNVERIFIED';
export const verified = 'VERIFIED';
export const pending = 'VERIFICATION_PENDING';

export const noneRecommend = 'NONE';
export const searchRecommend = 'SEARCH';
